import { FilterBar } from '@/components/filters/FilterBar';
import { SearchInput } from '@/components/filters/SearchInput';
import { Button } from '@/components/ui/Button';
import { useAdminOrganisations } from '@/hooks/useAdminOrganisations';
import { Download } from 'lucide-react';
import { useState } from 'react';
import { OrganisationsTable } from '../components/OrganisationsTable';
import { exportToExcel } from '@/utils/export';

export function OrganisationsListPage() {
  const [search, setSearch] = useState('');
  const { data, isLoading } = useAdminOrganisations({ search, limit: 25 });
  const orgs = data?.data || [];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Organisations</h1>
          <p className="text-sm text-neutral-500">{data?.pagination?.totalItems ?? 0} organisations</p>
        </div>
        <Button variant="outline" size="sm" icon={<Download className="h-4 w-4" />} onClick={() => exportToExcel(orgs, 'organisations')}>
          Exporter
        </Button>
      </div>
      <FilterBar>
        <div className="w-72">
          <SearchInput value={search} onChange={setSearch} placeholder="Rechercher une organisation..." />
        </div>
      </FilterBar>
      <OrganisationsTable data={orgs} loading={isLoading} />
    </div>
  );
}
